import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../shared/source/context/context';
import { userPaginationSchema } from '../../../../../shared/source/data-contract/user';

import type { FilterRequest } from '../../../../../shared/source/data-contract/filter';
import type { PaginatedUsers } from '../../../../../shared/source/data-contract/user';
import type { UseQueryResult } from '@tanstack/react-query';

const pathname = '/users/filter';

export const useUsersFilterQuery = (
    { filter, paged = { page: 0, size: 20 }, sorted }: FilterRequest,
    enabled: boolean,
): UseQueryResult<PaginatedUsers> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    return useQuery({
        enabled,
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.postJson(userPaginationSchema, {
                pathname,
                payload: {
                    filter,
                    paged,
                    sorted,
                },
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },

        queryKey: [pathname, 'postJson', filter, paged, sorted],
    });
};
